import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, formatApiErrorDetail } from '../lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    // If we're returning from an OAuth callback, let AuthCallback handle it.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    setError('');
    try {
      const { data } = await api.post('/auth/login', { email, password });
      if (data.token) localStorage.setItem('bb_token', data.token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (e) {
      // Best-effort server-side logout — always clear local state below.
      console.warn('Server logout failed, clearing local session anyway:', e?.response?.status || e?.message);
    }
    localStorage.removeItem('bb_token');
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, error, refresh: load }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
